var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.actived)?_c('v-alert',{staticClass:"information",attrs:{"prominent":"","type":_vm.type,"dismissible":_vm.isClosed}},[_c('v-row',[_c('v-col',{staticClass:"grow"},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('span',{attrs:{"id":"span-html"},domProps:{"innerHTML":_vm._s(_vm.text)}})])],1)],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }